import axios from 'axios';

const CategoryService = {
  getAll() {
    return axios.get('category').catch((error) => {
      throw new Error(`CategoryService.getAll ${error}`);
    });
  },
  get(id) {
    return axios.get(`category/${id}`).catch((error) => {
      throw new Error(`CategoryService.get ${error}`);
    });
  },
};

export default CategoryService;
